export default __webpack_public_path__ + "static/media/Master Control.fca02676.png";